import React, { useEffect, useState } from 'react';
import { Tabs, Typography } from 'antd';
import { getRatingAccess } from '../services/api';
import TemplatesTab from '../components/rating/TemplatesTab';
import VisitsTab from '../components/rating/VisitsTab';

const { Title } = Typography;

const QualityAuditPage: React.FC = () => {
  const [canManageTemplates, setCanManageTemplates] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getRatingAccess()
      .then((res) => setCanManageTemplates(res.data.can_manage_templates))
      .catch(() => setCanManageTemplates(false))
      .finally(() => setLoaded(true));
  }, []);

  const tabs = [{ key: 'visits', label: 'Audit Visits', children: <VisitsTab /> }];
  if (canManageTemplates) {
    tabs.push({ key: 'templates', label: 'Rating Templates', children: <TemplatesTab /> });
  }

  return (
    <div style={{ padding: 24 }}>
      <Title level={3} style={{ marginTop: 0 }}>Quality Audit</Title>
      {loaded && <Tabs items={tabs} />}
    </div>
  );
};

export default QualityAuditPage;
